// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"arrowRightWithLoadingIndicator_loadingSpinner__hr_CV"};